/**
 * Owner: Masa Bayu
 * File: batch07-fixtures.ts
 * Date:Time: 2026-09-20 00:59
 * Description: Batch 7 certification fixtures — regional scripts (56).
 */
import { QX_BATCH_07_FAMILY_IDS, } from './batch07-codes';
const SCRIPT_LABEL = Object.freeze({
    armenian: 'Armn',
    georgian: 'Geor',
    ethiopic: 'Ethi',
    tibetan: 'Tibt',
});
function fixturesFor(familyId) {
    const scriptLabel = SCRIPT_LABEL[familyId];
    const shapingNote = familyId === 'tibetan'
        ? 'complex shaping · syllable stacks'
        : 'LTR regional orthography · whitespace-safe';
    return Object.freeze([
        Object.freeze({
            id: `fixture:${familyId}/identity`,
            familyId,
            area: 'identity',
            description: `canonical languageId samples for ${familyId}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/script-character`,
            familyId,
            area: 'script',
            description: `${scriptLabel} · ${shapingNote}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/direction-ltr`,
            familyId,
            area: 'direction',
            description: 'LTR default + explicit ltr override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/content-multilingual`,
            familyId,
            area: 'content',
            description: 'primary + contentLanguages',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxw-author-preserve`,
            familyId,
            area: 'qxw',
            description: 'QXW root metadata author → preserve',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxp-publish-preserve`,
            familyId,
            area: 'qxp',
            description: 'QXP artifact preserve-through-publish',
        }),
        Object.freeze({
            id: `fixture:${familyId}/reader-typography`,
            familyId,
            area: 'reader',
            description: `${scriptLabel} typography stacks · glyph coverage contract`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/search-regional`,
            familyId,
            area: 'search',
            description: 'NFC + per-script analyzer · regional segment path',
        }),
        Object.freeze({
            id: `fixture:${familyId}/navigation-structure`,
            familyId,
            area: 'navigation',
            description: 'writing mode + heading role metadata',
        }),
        Object.freeze({
            id: `fixture:${familyId}/annotation-anchors`,
            familyId,
            area: 'annotation',
            description: 'original text preserved for selection/annotation anchors',
        }),
        Object.freeze({
            id: `fixture:${familyId}/a11y-lang-semantics`,
            familyId,
            area: 'accessibility',
            description: 'content lang + LTR reading order for AT',
        }),
        Object.freeze({
            id: `fixture:${familyId}/serialize-roundtrip`,
            familyId,
            area: 'serialization',
            description: 'metadata / content round-trip',
        }),
        Object.freeze({
            id: `fixture:${familyId}/regression-suite`,
            familyId,
            area: 'regression',
            description: 'content id stable under override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/provenance-chain`,
            familyId,
            area: 'provenance',
            description: 'source → evidence area trace',
        }),
    ]);
}
const BY_FAMILY = Object.freeze(Object.fromEntries(QX_BATCH_07_FAMILY_IDS.map((id) => [id, fixturesFor(id)])));
export const QX_BATCH_07_FIXTURES = Object.freeze(QX_BATCH_07_FAMILY_IDS.flatMap((id) => [...BY_FAMILY[id]]));
export const QX_BATCH_07_SAMPLE_LANGUAGES = Object.freeze({
    armenian: Object.freeze(['hy']),
    georgian: Object.freeze(['ka']),
    ethiopic: Object.freeze(['am', 'ti']),
    tibetan: Object.freeze(['bo']),
});
export const QX_BATCH_07_TEXT_SAMPLES = Object.freeze({
    hy: 'Բարեւ աշխարհ—հայերեն հավաստագրում նմուշ',
    ka: 'გამარჯობა მსოფლიო—ქართული სერტიფიკაცია ნიმუში',
    am: 'ሰላም ዓለም—አማርኛ የማረጋገጫ ናሙና',
    bo: 'བཀྲ་ཤིས་བདེ་ལེགས།—བོད་ཡིག་ངོས་འཛིན་དཔེ།',
    composed: 'cafe\u0301',
});
export function listBatch07FixtureIds(familyId) {
    const list = familyId ? BY_FAMILY[familyId] : QX_BATCH_07_FIXTURES;
    return Object.freeze(list.map((f) => f.id));
}
export function fixturesForBatch07Family(familyId) {
    return BY_FAMILY[familyId];
}
//# sourceMappingURL=batch07-fixtures.js.map